module.exports = __webpack_public_path__ + "images/company/rank_medal/request_count_rank/5_6855f392d1ec17941e12bcf943e9988d.png";